module.exports = __webpack_public_path__ + "components/tide-table/static/moon-new-moon-73951930de95c6e6bb63946999d70206.svg";